/* trofera.pl – personalizacja na karcie produktu, wersja 6.2 (26.10.2026)
   - pola treści (tabliczka / grawer / nadruk), plik z logo, osobne napisy dla każdej sztuki (do 12),
     potwierdzenie pisowni, ukrywanie „Kup teraz” przy personalizacji (z wersji 5);
   - NOWE: edytor wizualny – napis i logo można przesuwać (mysz, palec, strzałki), powiększać i zmniejszać,
     zmieniać krój i wyrównanie, grafikę obracać; dwa widoki: „Tabliczka” (puchary) i „Na produkcie”
     (szkło oraz puchary „motyw własny”); przy dodaniu do koszyka do zamówienia trafia opis układu
     („Układ projektu”), dane techniczne (_projekt) i plik „Podgląd projektu” (JPG).
   6.2: wysokie zdjęcia mieszczą się na ekranie telefonu; w „motywie własnym” grafika tylko na wkładce.
   6.1: tryb mieszania logo na tabliczce i szkle, ciemne tło podglądu grawerowanego szkła, okrągła wkładka
     w pucharach „motyw własny”, mniejszy plik podglądu, układ napisu i logo bez nachodzenia.
   Dane wariantów: JSON w [data-ts-map] generowany przez snippets/ts-personalizacja.liquid. */
(function () {
  'use strict';
  if (window.tsPersoBoot) { window.tsPersoBoot(); return; }

  var FONTS = {
    serif: { css: "Georgia, 'Times New Roman', serif", weight: '400', label: 'klasyczny (szeryfowy)' },
    sans: { css: "'Helvetica Neue', Arial, sans-serif", weight: '400', label: 'nowoczesny (bezszeryfowy)' },
    bold: { css: "'Arial Black', 'Helvetica Neue', Arial, sans-serif", weight: '700', label: 'pogrubiony' },
    script: { css: "'Brush Script MT', 'Segoe Script', 'Lucida Handwriting', cursive", weight: '400', label: 'ozdobny (pisany)' }
  };
  var ALIGN_PL = { left: 'do lewej', center: 'do środka', right: 'do prawej' };
  var DECO_PL = {
    grawer: 'grawer laserowy – na podglądzie matowa biel, ciemne tło tylko dla czytelności',
    farba: 'grawer wypełniony farbą – na podglądzie złoty, kolor wypełnienia ustalimy w projekcie',
    nadruk: 'nadruk kolorowy'
  };
  var PREVIEWABLE = /^image\/(png|jpe?g|webp|gif|svg\+xml)$/i;
  var LH = 1.18;

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function copy(o) { return JSON.parse(JSON.stringify(o)); }
  function plural(n, one, few, many) {
    var n10 = n % 10, n100 = n % 100;
    if (n === 1) return one;
    if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return few;
    return many;
  }
  function plateDims(p) {
    var m = p ? String(p).match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i) : null;
    if (!m) return null;
    var w = parseFloat(m[1].replace(',', '.')), h = parseFloat(m[2].replace(',', '.'));
    return { w: w, h: h, label: m[1] + ' × ' + m[2], chars: Math.max(8, Math.floor((w - 8) / 2.6)), lines: Math.max(1, Math.floor((h - 4) / 5.5)) };
  }
  function plateInfo(p) {
    if (!p) return '';
    var d = plateDims(p);
    if (!d) return 'Tabliczka: <strong>' + p + ' mm</strong>';
    return 'Tabliczka <strong>' + d.label + ' mm</strong> – zmieści się ok. ' + d.lines + ' ' +
      plural(d.lines, 'wiersz', 'wiersze', 'wierszy') + ' po ~' + d.chars + ' ' + plural(d.chars, 'znak', 'znaki', 'znaków');
  }
  function fmt(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }
  function where(x, y) {
    var h = x < 40 ? 'lewa strona' : x > 60 ? 'prawa strona' : 'środek';
    var v = y < 40 ? 'u góry' : y > 60 ? 'u dołu' : '';
    return v ? h + ', ' + v : h;
  }

  function descFix() {
    /* w opisie produktu stare wskazówki „podaj w uwagach do zamówienia” zastępujemy informacją o polu personalizacji */
    if (window.__tsDescFixed) return;
    window.__tsDescFixed = true;
    var pairs = [
      ['nazwę zawodów, miejsce, datę, logo – podaj w uwagach do zamówienia;', 'nazwę zawodów, miejsce, datę – wpiszesz w polu nad przyciskiem „Dodaj do koszyka” (pojawi się po wybraniu wariantu z tabliczką), tam też dodasz plik z logo;'],
      [' i podaj treść w uwagach do zamówienia.', ', a treść napisu wpisz w polu, które pojawi się nad przyciskiem „Dodaj do koszyka”.'],
      [' i podaj treść napisu w uwagach do zamówienia.', ', a treść napisu wpisz w polu, które pojawi się nad przyciskiem „Dodaj do koszyka”.'],
      ['Treść grawerunku, logo lub projekt nadruku prześlij w uwagach do zamówienia.', 'Treść grawerunku wpiszesz, a logo lub projekt nadruku dodasz jako plik w polu nad przyciskiem „Dodaj do koszyka” – pojawi się po wybraniu wersji z grawerem lub nadrukiem.']
    ];
    document.querySelectorAll('.product__description').forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue, t0 = t;
        for (var i = 0; i < pairs.length; i++) {
          if (t.indexOf(pairs[i][0]) !== -1) t = t.split(pairs[i][0]).join(pairs[i][1]);
        }
        if (t !== t0) node.nodeValue = t;
      }
    });
  }

  /* ================= edytor wizualny ================= */
  function Designer(box, api) {
    var root = box.querySelector('[data-ts-des]');
    if (!root) return null;
    var stage = root.querySelector('[data-ts-stage]');
    var note = root.querySelector('[data-ts-note]');
    var surfBtns = root.querySelectorAll('[data-surface]');
    var surfGroup = root.querySelector('[data-ts-surfaces]');
    var layerBtns = root.querySelectorAll('[data-layer]');
    var size = root.querySelector('[data-ts-size]');
    var sizeVal = root.querySelector('[data-ts-size-val]');
    var font = root.querySelector('[data-ts-font]');
    var color = root.querySelector('[data-ts-color]');
    var rot = root.querySelector('[data-ts-rot]');
    var rotVal = root.querySelector('[data-ts-rot-val]');
    var neg = root.querySelector('[data-ts-neg]');
    var alignBtns = root.querySelectorAll('[data-align]');
    var outLayout = root.querySelector('[data-ts-layout]');
    var outJson = root.querySelector('[data-ts-json]');
    var outSnap = root.querySelector('[data-ts-snap]');
    var kind = box.dataset.kind;

    var custom = box.dataset.custom === '1';
    var DEF = {
      plate: { text: { x: 50, y: 50, s: 100, font: 'serif', align: 'center' }, img: { x: 16, y: 50, w: 24, r: 0 } },
      photo: { text: { x: 50, y: 64, s: 100, font: 'serif', align: 'center', color: '#1a1a1a' }, img: custom ? { x: 50, y: 26, w: 30, r: 0 } : { x: 50, y: 30, w: 28, r: 0 } }
    };
    /* „motyw własny”: wkładka pucharu jest okrągła – opcja przycięcia grafiki do koła (dodawana tylko tu) */
    var round = null;
    if (custom) {
      var more = root.querySelector('.ts-des__tools--more');
      if (more) {
        var rr = document.createElement('div');
        rr.className = 'ts-des__row';
        rr.setAttribute('data-only', 'img');
        rr.setAttribute('data-photo-only', '');
        rr.innerHTML = '<label class="ts-des__toggle"><input type="checkbox" data-ts-round> Przytnij grafikę do koła (okrągła wkładka)</label>';
        more.insertBefore(rr, more.firstChild);
        round = rr.querySelector('input');
      }
    }
    function isRound() { return !!(round && round.checked); }
    var S = copy(DEF);
    var surface = 'plate', layer = 'text', dirty = { plate: false, photo: false };
    var info = { on: false }, dims = null, deco = 'grawer';
    var logo = null; /* { url, name, el (Image) } */
    var photoImg = null, photoRatio = 0.75;
    var els = {};

    function avail(s) {
      if (!info.on) return false;
      if (s === 'plate') return kind === 'puchar' && !!info.tab && !!dims;
      return !!info.img && (kind === 'szklo' || custom);
    }
    function textOn(s) { return s === 'plate' || kind === 'szklo'; }
    function imgOn() { return !!(logo && logo.ok); }
    /* w pucharach „motyw własny” grafika trafia na wkładkę, a tabliczka zostaje na sam napis */
    function imgAt(s) { return imgOn() && !(custom && s === 'plate'); }

    /* --- budowa sceny --- */
    function build() {
      stage.innerHTML = '';
      els = {};
      stage.className = 'ts-des__stage ts-des__stage--' + surface;
      stage.style.maxWidth = '';
      if (surface === 'plate') {
        stage.style.aspectRatio = dims.w + ' / ' + dims.h;
        stage.setAttribute('aria-label', 'Podgląd tabliczki ' + dims.label + ' mm');
      } else {
        stage.style.aspectRatio = String(photoRatio);
        stage.setAttribute('aria-label', 'Podgląd na produkcie');
        var im = document.createElement('img');
        im.className = 'ts-des__photo';
        im.alt = '';
        im.decoding = 'async';
        im.src = info.img;
        im.addEventListener('load', function () {
          if (im.naturalWidth && im.naturalHeight) {
            photoRatio = im.naturalWidth / im.naturalHeight;
            stage.style.aspectRatio = String(photoRatio);
            /* małe zdjęcie (np. 145 px) nie jest rozciągane na całą szerokość, a wysokie (np. obelisk)
               mieści się w ok. 55% wysokości ekranu – napis, logo i przyciski widać razem */
            var cap = Math.round((window.innerHeight || 800) * 0.55 * photoRatio);
            if (im.naturalWidth < 400) cap = Math.min(cap, Math.max(240, Math.round(im.naturalWidth * 2.2)));
            stage.style.maxWidth = cap < 420 ? Math.max(200, cap) + 'px' : '';
          }
          photoImg = im;
          render();
        });
        stage.appendChild(im);
        photoImg = im.complete && im.naturalWidth ? im : null;
      }
      if (textOn(surface)) {
        var t = document.createElement('div');
        t.className = 'ts-des__layer ts-des__text';
        t.tabIndex = 0;
        t.setAttribute('role', 'group');
        t.setAttribute('aria-roledescription', 'element projektu');
        t.setAttribute('aria-label', 'Napis – przesuń strzałkami, plus i minus zmieniają wielkość');
        t.dataset.lyr = 'text';
        stage.appendChild(t);
        els.text = t;
        bindLayer(t, 'text');
      }
      if (imgAt(surface)) {
        var w = document.createElement('div');
        w.className = 'ts-des__layer ts-des__img';
        w.tabIndex = 0;
        w.setAttribute('role', 'group');
        w.setAttribute('aria-roledescription', 'element projektu');
        w.setAttribute('aria-label', 'Logo lub grafika – przesuń strzałkami, plus i minus zmieniają wielkość');
        w.dataset.lyr = 'img';
        var li = document.createElement('img');
        li.alt = '';
        li.src = logo.url;
        w.appendChild(li);
        stage.appendChild(w);
        els.img = w;
        bindLayer(w, 'img');
      }
      if (!els[layer]) layer = els.text ? 'text' : 'img';
      syncControls();
      render();
    }

    /* --- wielkość napisu: dopasowanie bazowe × skala użytkownika --- */
    function baseFont(s, W, H, rows, longest) {
      if (s === 'plate') {
        var w = W * (imgAt('plate') ? 0.6 : 0.9), h = H * 0.86;
        return Math.min(h / (rows * LH), w / (longest * 0.55), h * 0.24);
      }
      return W * 0.055;
    }
    function textInfo() {
      var v = api.text();
      var empty = !v.trim();
      var shown = empty ? api.sample() : v;
      var rows = shown.split('\n');
      var longest = 1;
      rows.forEach(function (r) { longest = Math.max(longest, r.length); });
      return { value: v, empty: empty, shown: shown, rows: rows.length, longest: longest };
    }
    function fontPx(s, W, H, ti) {
      return Math.max(3, baseFont(s, W, H, ti.rows, ti.longest) * S[s].text.s / 100);
    }

    function render() {
      if (root.hidden || !els) return;
      var rect = stage.getBoundingClientRect();
      var over = false, msg = [];
      var L = S[surface];
      if (els.text) {
        var ti = textInfo();
        var t = els.text;
        t.textContent = ti.shown;
        t.classList.toggle('is-placeholder', ti.empty);
        var f = FONTS[L.text.font] || FONTS.serif;
        t.style.fontFamily = f.css;
        t.style.fontWeight = f.weight;
        t.style.textAlign = L.text.align;
        t.style.left = L.text.x + '%';
        t.style.top = L.text.y + '%';
        t.style.color = surface === 'photo' && deco === 'nadruk' ? L.text.color : '';
        if (rect.width > 0) {
          var fs = fontPx(surface, rect.width, rect.height, ti);
          t.style.fontSize = fs.toFixed(1) + 'px';
          var tr = t.getBoundingClientRect();
          var out = tr.left < rect.left - 1 || tr.right > rect.right + 1 || tr.top < rect.top - 1 || tr.bottom > rect.bottom + 1;
          if (surface === 'plate') {
            var mm = fs * 0.7 * dims.h / rect.height;
            var tooMany = !ti.empty && (ti.rows > dims.lines || ti.longest > dims.chars);
            if (out && !ti.empty) { over = true; msg.push('Napis wychodzi poza tabliczkę – zmniejsz go albo skróć tekst.'); }
            else if (tooMany) { over = true; msg.push('Napis jest dłuższy niż zalecany dla tej tabliczki (ok. ' + dims.lines + ' ' + plural(dims.lines, 'wiersz', 'wiersze', 'wierszy') + ' po ~' + dims.chars + ' znaków).'); }
            if (!ti.empty && mm < 2) { over = true; msg.push('Litery mniejsze niż 2 mm mogą być nieczytelne.'); }
            msg.push('Wysokość liter ok. ' + fmt(mm) + ' mm na tabliczce ' + dims.label + ' mm.');
          } else if (out && !ti.empty) {
            over = true;
            msg.push('Napis wychodzi poza zdjęcie – zmniejsz go.');
          }
        }
      }
      if (els.img) {
        var g = L.img;
        els.img.style.width = g.w + '%';
        els.img.style.left = g.x + '%';
        els.img.style.top = g.y + '%';
        els.img.style.transform = 'translate(-50%, -50%) rotate(' + g.r + 'deg)';
        if (rect.width > 0) {
          var ir = els.img.getBoundingClientRect();
          if (ir.left < rect.left - 2 || ir.right > rect.right + 2 || ir.top < rect.top - 2 || ir.bottom > rect.bottom + 2) {
            over = true;
            msg.push(surface === 'plate' ? 'Logo wychodzi poza tabliczkę – zmniejsz je albo przesuń.' : 'Grafika wychodzi poza zdjęcie – zmniejsz ją albo przesuń.');
          }
        }
      }
      Object.keys(els).forEach(function (k) { els[k].classList.toggle('is-active', k === layer); });
      if (els.text && els.img && !textInfo().empty) {
        var a = els.text.getBoundingClientRect(), b = els.img.getBoundingClientRect();
        var ix = Math.min(a.right, b.right) - Math.max(a.left, b.left), iy = Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top);
        if (ix > 4 && iy > 4) { over = true; msg.push('Napis nachodzi na logo – przesuń jeden z elementów albo go zmniejsz.'); }
      }
      if (surface === 'photo') msg.push('Efekt: ' + DECO_PL[deco] + '.');
      if (logo && !logo.ok) msg.push('Plik „' + logo.name + '” dołączymy do zamówienia – podgląd działa dla PNG, JPG, WEBP i SVG.');
      msg.push('Podgląd jest poglądowy – przed wykonaniem ' + (kind === 'szklo' || surface === 'photo' ? 'wyślemy projekt do akceptacji.' : 'sprawdzimy układ napisu.'));
      root.classList.toggle('is-over', over);
      note.textContent = msg.join(' ');
      syncOutputs();
    }

    /* --- sterowanie --- */
    function current() { return S[surface][layer]; }
    function syncControls() {
      var L = S[surface];
      layerBtns.forEach(function (b) {
        var l = b.dataset.layer;
        var has = !!els[l];
        b.disabled = !has;
        b.setAttribute('aria-pressed', String(has && l === layer));
      });
      root.querySelectorAll('[data-only]').forEach(function (row) { row.hidden = row.dataset.only !== layer; });
      root.querySelectorAll('[data-photo-only]').forEach(function (row) {
        if (surface !== 'photo') row.hidden = true;
      });
      var colorRow = root.querySelector('[data-color-row]');
      if (colorRow && !(surface === 'photo' && deco === 'nadruk' && layer === 'text')) colorRow.hidden = true;
      var negRow = root.querySelector('[data-neg-row]');
      if (negRow && !(surface === 'photo' && deco !== 'nadruk' && layer === 'img')) negRow.hidden = true;
      if (layer === 'text') {
        size.min = 40; size.max = 220; size.step = 5; size.value = L.text.s;
        sizeVal.textContent = L.text.s + '%';
        font.value = L.text.font;
        alignBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.align === L.text.align)); });
        if (color) color.value = L.text.color || '#1a1a1a';
      } else {
        size.min = 6; size.max = 100; size.step = 1; size.value = L.img.w;
        sizeVal.textContent = L.img.w + '%';
        rot.value = L.img.r;
        rotVal.textContent = L.img.r + '°';
      }
      size.setAttribute('aria-valuetext', sizeVal.textContent);
      surfBtns.forEach(function (b) {
        var s = b.dataset.surface;
        b.hidden = !avail(s);
        b.setAttribute('aria-pressed', String(s === surface));
      });
      if (surfGroup) surfGroup.hidden = !(avail('plate') && avail('photo'));
    }
    function change(fn) {
      fn();
      dirty[surface] = true;
      syncControls();
      render();
    }
    function setLayer(l) {
      if (!els[l]) return;
      layer = l;
      syncControls();
      render();
    }
    function resize(step) {
      change(function () {
        var c = current();
        if (layer === 'text') c.s = clamp(c.s + step * 10, 40, 220);
        else c.w = clamp(c.w + step * 3, 6, 100);
      });
    }
    function move(dx, dy) {
      change(function () {
        var c = current();
        c.x = clamp(c.x + dx, 0, 100);
        c.y = clamp(c.y + dy, 0, 100);
      });
    }
    function bindLayer(el, l) {
      var start = null;
      el.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        e.preventDefault();
        setLayer(l);
        el.focus({ preventScroll: true });
        var c = S[surface][l];
        start = { px: e.clientX, py: e.clientY, x: c.x, y: c.y, rect: stage.getBoundingClientRect() };
        el.classList.add('is-dragging');
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
      });
      el.addEventListener('pointermove', function (e) {
        if (!start || !start.rect.width) return;
        var c = S[surface][l];
        c.x = Math.round(clamp(start.x + (e.clientX - start.px) / start.rect.width * 100, 0, 100) * 10) / 10;
        c.y = Math.round(clamp(start.y + (e.clientY - start.py) / start.rect.height * 100, 0, 100) * 10) / 10;
        dirty[surface] = true;
        render();
      });
      function end() {
        if (!start) return;
        start = null;
        el.classList.remove('is-dragging');
        syncControls();
        render();
      }
      el.addEventListener('pointerup', end);
      el.addEventListener('pointercancel', end);
      el.addEventListener('focus', function () { if (layer !== l) setLayer(l); });
      el.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 5 : 1;
        var k = e.key;
        if (k === 'ArrowLeft') move(-step, 0);
        else if (k === 'ArrowRight') move(step, 0);
        else if (k === 'ArrowUp') move(0, -step);
        else if (k === 'ArrowDown') move(0, step);
        else if (k === '+' || k === '=') resize(1);
        else if (k === '-' || k === '_') resize(-1);
        else return;
        e.preventDefault();
      });
    }

    surfBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!avail(b.dataset.surface) || surface === b.dataset.surface) return;
        surface = b.dataset.surface;
        build();
      });
    });
    layerBtns.forEach(function (b) { b.addEventListener('click', function () { setLayer(b.dataset.layer); }); });
    size.addEventListener('input', function () {
      change(function () {
        var v = parseInt(size.value, 10);
        if (layer === 'text') current().s = v; else current().w = v;
      });
    });
    font.addEventListener('change', function () { change(function () { S[surface].text.font = font.value; }); });
    if (color) color.addEventListener('input', function () { change(function () { S[surface].text.color = color.value; }); });
    rot.addEventListener('input', function () { change(function () { S[surface].img.r = parseInt(rot.value, 10) || 0; }); });
    if (neg) neg.addEventListener('change', function () { root.classList.toggle('is-negative', neg.checked); dirty.photo = true; render(); });
    if (round) round.addEventListener('change', function () { root.classList.toggle('is-round', round.checked); dirty.photo = true; render(); });
    alignBtns.forEach(function (b) { b.addEventListener('click', function () { change(function () { S[surface].text.align = b.dataset.align; }); }); });
    root.querySelectorAll('[data-act]').forEach(function (b) {
      b.addEventListener('click', function () {
        var a = b.dataset.act;
        if (a === 'smaller') resize(-1);
        else if (a === 'bigger') resize(1);
        else if (a === 'up') move(0, -2);
        else if (a === 'down') move(0, 2);
        else if (a === 'left') move(-2, 0);
        else if (a === 'right') move(2, 0);
        else if (a === 'rotl') change(function () { S[surface].img.r = clamp(S[surface].img.r - 15, -180, 180); });
        else if (a === 'rotr') change(function () { S[surface].img.r = clamp(S[surface].img.r + 15, -180, 180); });
        else if (a === 'center') change(function () { current().x = 50; current().y = 50; });
        else if (a === 'reset') {
          S[surface] = copy(DEF[surface]);
          if (surface === 'plate' && imgAt('plate')) S.plate.text.x = 62;
          dirty[surface] = false;
          if (neg) { neg.checked = false; root.classList.remove('is-negative'); }
          if (round) { round.checked = false; root.classList.remove('is-round'); }
          syncControls();
          render();
        }
      });
    });
    window.addEventListener('resize', function () { render(); });

    /* --- logo z pola pliku --- */
    function setFile(f) {
      if (logo && logo.url) { try { URL.revokeObjectURL(logo.url); } catch (e) {} }
      logo = null;
      if (f) {
        var ok = PREVIEWABLE.test(f.type || '');
        logo = { name: f.name, ok: ok, url: ok ? URL.createObjectURL(f) : null, el: null };
        if (ok) {
          var im = new Image();
          im.onload = function () { logo && (logo.el = im); render(); };
          im.src = logo.url;
          if (!dirty.plate && !custom) S.plate.text.x = 62;
          layer = 'img';
          /* „motyw własny”: grafika trafia na wkładkę pucharu – pokaż widok „Na produkcie” */
          if (custom && avail('photo')) surface = 'photo';
        }
      } else {
        if (!dirty.plate) S.plate.text.x = 50;
        layer = 'text';
      }
      if (!root.hidden) build();
    }

    /* --- dane do zamówienia --- */
    function hasContent() { return !!api.text().trim() || imgOn(); }
    function describe() {
      var parts = [];
      ['plate', 'photo'].forEach(function (s) {
        if (!avail(s)) return;
        var L = S[s], p = [];
        if (textOn(s) && api.text().trim()) {
          var t = 'napis ' + L.text.s + '%';
          if (s === 'plate' && dims && els.text && surface === 'plate') {
            var r = stage.getBoundingClientRect();
            if (r.height) t += ' (litery ok. ' + fmt(parseFloat(els.text.style.fontSize) * 0.7 * dims.h / r.height) + ' mm)';
          }
          t += ', krój ' + (FONTS[L.text.font] || FONTS.serif).label + ', ' + ALIGN_PL[L.text.align];
          if (L.text.x !== 50 || L.text.y !== 50) t += ', ' + where(L.text.x, L.text.y);
          if (s === 'photo' && deco === 'nadruk') t += ', kolor ' + L.text.color;
          p.push(t);
        }
        if (imgAt(s)) {
          p.push('grafika ' + L.img.w + '% szerokości, ' + where(L.img.x, L.img.y) + (L.img.r ? ', obrót ' + L.img.r + '°' : '') + (s === 'photo' && neg && neg.checked ? ', negatyw' : '') + (s === 'photo' && isRound() ? ', przycięta do koła' : ''));
        }
        if (p.length) parts.push((s === 'plate' ? 'Tabliczka: ' : 'Na produkcie: ') + p.join('; '));
      });
      return parts.join(' | ');
    }
    function active() { return !root.hidden && (dirty.plate || dirty.photo || imgOn()) && hasContent(); }
    function syncOutputs() {
      var on = active();
      outLayout.disabled = !on;
      outJson.disabled = !on;
      if (on) {
        outLayout.value = describe();
        outJson.value = JSON.stringify({ v: 6, deco: deco, plate: dims ? dims.label : null, s: S, neg: !!(neg && neg.checked), round: isRound() });
      }
    }

    /* --- plik JPG z podglądem (generowany przy dodaniu do koszyka) --- */
    function drawText(ctx, s, X, Y, W, H) {
      var ti = textInfo();
      if (ti.empty) return;
      var L = S[s].text, f = FONTS[L.font] || FONTS.serif;
      var fs = fontPx(s, W, H, ti);
      ctx.save();
      ctx.font = f.weight + ' ' + fs + 'px ' + f.css;
      ctx.textBaseline = 'middle';
      var lines = ti.value.replace(/\r/g, '').split('\n');
      var maxW = 0;
      lines.forEach(function (l) { maxW = Math.max(maxW, ctx.measureText(l).width); });
      var cx = X + W * L.x / 100, cy = Y + H * L.y / 100, lh = fs * LH;
      var ax = L.align === 'left' ? cx - maxW / 2 : L.align === 'right' ? cx + maxW / 2 : cx;
      ctx.textAlign = L.align;
      if (s === 'plate') { ctx.fillStyle = '#2a2108'; }
      else if (deco === 'nadruk') { ctx.fillStyle = L.color || '#1a1a1a'; }
      else if (deco === 'farba') { ctx.fillStyle = '#d9b63a'; ctx.shadowColor = 'rgba(0,0,0,.45)'; ctx.shadowBlur = 2; }
      else { ctx.fillStyle = 'rgba(255,255,255,.95)'; ctx.shadowColor = 'rgba(0,0,0,.55)'; ctx.shadowBlur = Math.max(1, fs / 12); }
      var y0 = cy - (lines.length * lh) / 2 + lh / 2;
      lines.forEach(function (l, i) { ctx.fillText(l, ax, y0 + i * lh); });
      ctx.restore();
    }
    /* grafika do pliku z podglądem: przetwarzanie pikseli zamiast ctx.filter (Safari do wersji 17 go nie obsługuje) */
    function logoCanvas(w, h, mode, rnd) {
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(w));
      c.height = Math.max(1, Math.round(h));
      var x = c.getContext('2d');
      var nw = logo.el.naturalWidth, nh = logo.el.naturalHeight;
      if (rnd) {
        /* kwadratowy wycinek ze środka grafiki (jak object-fit: cover) */
        var m = Math.min(nw, nh);
        x.drawImage(logo.el, (nw - m) / 2, (nh - m) / 2, m, m, 0, 0, c.width, c.height);
      } else {
        x.drawImage(logo.el, 0, 0, c.width, c.height);
      }
      if (mode !== 'color') {
        var d = x.getImageData(0, 0, c.width, c.height), p = d.data;
        for (var i = 0; i < p.length; i += 4) {
          var v = 0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2];
          if (mode === 'engrave') v = 255 - v;
          v = clamp((v - 128) * 1.4 + 128, 0, 255);
          p[i] = p[i + 1] = p[i + 2] = v;
        }
        x.putImageData(d, 0, 0);
      }
      if (rnd) {
        x.globalCompositeOperation = 'destination-in';
        x.beginPath();
        x.arc(c.width / 2, c.height / 2, c.width / 2, 0, Math.PI * 2);
        x.fill();
      }
      return c;
    }
    function drawLogo(ctx, s, X, Y, W, H) {
      if (!imgAt(s) || !logo.el || !logo.el.naturalWidth) return;
      var g = S[s].img;
      var rnd = s === 'photo' && isRound();
      var w = W * g.w / 100, h = rnd ? w : w * logo.el.naturalHeight / logo.el.naturalWidth;
      var mode = 'color', op = 'source-over', alpha = 1;
      if (s === 'plate') { mode = 'gray'; op = 'multiply'; }
      else if (deco !== 'nadruk') { mode = neg && neg.checked ? 'gray' : 'engrave'; op = 'screen'; alpha = .9; }
      var src;
      try { src = logoCanvas(w, h, mode, rnd); } catch (e) { src = logo.el; }
      ctx.save();
      ctx.translate(X + W * g.x / 100, Y + H * g.y / 100);
      ctx.rotate(g.r * Math.PI / 180);
      ctx.globalCompositeOperation = op;
      ctx.globalAlpha = alpha;
      ctx.drawImage(src, -w / 2, -h / 2, w, h);
      ctx.restore();
    }
    function snapshot() {
      var parts = [];
      var W = 1000;
      if (avail('photo') && photoImg && photoImg.naturalWidth) parts.push({ s: 'photo', h: Math.round(W / (photoImg.naturalWidth / photoImg.naturalHeight)) });
      if (avail('plate')) parts.push({ s: 'plate', h: Math.round(W * dims.h / dims.w) });
      if (!parts.length) return null;
      var pad = 30, cap = 46;
      var total = pad + cap;
      parts.forEach(function (p) { total += p.h + pad; });
      var cv = document.createElement('canvas');
      cv.width = W + pad * 2;
      cv.height = total;
      var ctx = cv.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, cv.width, cv.height);
      var y = pad;
      parts.forEach(function (p) {
        var X = pad, Y = y, H = p.h;
        ctx.save();
        /* elementy przycięte do obszaru tabliczki / zdjęcia – jak na stronie */
        ctx.beginPath();
        ctx.rect(X, Y, W, H);
        ctx.clip();
        if (p.s === 'photo') {
          if (deco === 'grawer' || deco === 'farba') {
            /* jak na stronie: ciemne tło, zdjęcie szkła w trybie „multiply” – biały grawer jest czytelny */
            ctx.fillStyle = '#39414c';
            ctx.fillRect(X, Y, W, H);
            ctx.save();
            ctx.globalCompositeOperation = 'multiply';
            ctx.drawImage(photoImg, X, Y, W, H);
            ctx.restore();
          } else {
            ctx.drawImage(photoImg, X, Y, W, H);
          }
          if (textOn('photo')) drawText(ctx, 'photo', X, Y, W, H);
          drawLogo(ctx, 'photo', X, Y, W, H);
        } else {
          var gr = ctx.createLinearGradient(X, Y, X + W, Y + H);
          gr.addColorStop(0, '#a8822a'); gr.addColorStop(.38, '#f2dc94'); gr.addColorStop(.55, '#c9a227'); gr.addColorStop(.72, '#e9d083'); gr.addColorStop(1, '#8f6d14');
          ctx.fillStyle = gr;
          ctx.fillRect(X, Y, W, H);
          ctx.strokeStyle = 'rgba(0,0,0,.35)';
          ctx.strokeRect(X + .5, Y + .5, W - 1, H - 1);
          drawText(ctx, 'plate', X, Y, W, H);
          drawLogo(ctx, 'plate', X, Y, W, H);
        }
        ctx.restore();
        y += H + pad;
      });
      ctx.fillStyle = '#444';
      ctx.font = '400 18px Arial, sans-serif';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      ctx.fillText(('trofera.pl – podgląd poglądowy · ' + (box.dataset.title || '') + ' · ' + api.variantTitle()).slice(0, 110), pad, cv.height - cap / 2 - 6);
      var url;
      /* JPG zamiast PNG: plik ok. 4× mniejszy, szybsze dodanie do koszyka */
      try { url = cv.toDataURL('image/jpeg', 0.9); } catch (e) { return null; }
      var bin = atob(url.split(',')[1]);
      var arr = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
      return new File([arr], 'podglad-projektu.jpg', { type: 'image/jpeg' });
    }
    function attachSnapshot() {
      outSnap.disabled = true;
      if (!active() || typeof DataTransfer === 'undefined') return false;
      try {
        var f = snapshot();
        if (!f) return false;
        var dt = new DataTransfer();
        dt.items.add(f);
        outSnap.files = dt.files;
        outSnap.disabled = false;
        return true;
      } catch (e) { outSnap.disabled = true; return false; }
    }

    return {
      setInfo: function (inf, d) {
        info = inf || { on: false };
        dims = d;
        deco = info.deco || 'grawer';
        root.dataset.deco = deco;
        var any = avail('plate') || avail('photo');
        root.hidden = !any;
        if (!any) { syncOutputs(); return; }
        if (!avail(surface)) surface = avail('plate') ? 'plate' : 'photo';
        if (surface === 'photo' && avail('plate') && !dirty.photo && kind === 'puchar' && !imgOn()) surface = 'plate';
        build();
      },
      setFile: setFile,
      refresh: render,
      attach: attachSnapshot,
      release: function () { outSnap.disabled = true; }
    };
  }

  /* ================= pola personalizacji ================= */
  function init(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    var form = box.closest('form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var text = box.querySelector('[data-ts-text]');
    var file = box.querySelector('[data-ts-file]');
    var plate = box.querySelector('[data-ts-plate]');
    var count = box.querySelector('[data-ts-count]');
    var maxBytes = parseInt(box.dataset.maxMb || '20', 10) * 1024 * 1024;
    var map = {};
    try { map = JSON.parse(box.querySelector('[data-ts-map]').textContent); } catch (e) {}
    var root = form.closest('product-info') || form.closest('section') || document;
    descFix();

    var MAX_MULTI = 12;
    var multiWrap = box.querySelector('[data-ts-multi]');
    var multiToggle = box.querySelector('[data-ts-multi-toggle]');
    var multiList = box.querySelector('[data-ts-multi-list]');
    var multiHint = box.querySelector('[data-ts-multi-hint]');
    var confirmBox = box.querySelector('[data-ts-confirm]');
    var formId = form.getAttribute('id');
    var qtyInput = (formId && document.querySelector('input[name="quantity"][form="' + formId + '"]')) || form.querySelector('input[name="quantity"]');
    var activeField = text;
    var samplePlaceholder = (text.getAttribute('placeholder') || '').replace(/^np\.\s*/, '');
    var info = { on: false };

    var des = Designer(box, {
      text: function () { return text.disabled && !multiActive() ? '' : (activeField && activeField.value ? activeField.value : '').replace(/\r/g, ''); },
      sample: function () { return samplePlaceholder; },
      variantTitle: function () { return info.title || ''; }
    });

    function getQty() {
      var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return isNaN(q) || q < 1 ? 1 : q;
    }
    function multiActive() {
      return !box.hidden && !!multiToggle && multiToggle.checked && getQty() >= 2 && getQty() <= MAX_MULTI;
    }
    function hasAnyText() {
      if (multiActive()) {
        var any = false;
        multiList.querySelectorAll('textarea').forEach(function (t) { if (t.value.trim()) any = true; });
        return any;
      }
      return !!text.value.trim();
    }
    if (confirmBox) confirmBox.addEventListener('change', function () { box.classList.remove('needs-confirm'); });

    function bindField(t) {
      t.addEventListener('focus', function () { activeField = t; des && des.refresh(); });
      t.addEventListener('input', function () { activeField = t; des && des.refresh(); });
    }
    function addMultiItem(i, value) {
      var wrap = document.createElement('div');
      wrap.className = 'ts-multi__item';
      var id = (text.id || 'ts-text') + '-szt-' + i;
      var label = document.createElement('label');
      label.setAttribute('for', id);
      label.textContent = 'Sztuka ' + i;
      var t = document.createElement('textarea');
      t.id = id;
      t.rows = 3;
      t.maxLength = text.maxLength;
      t.name = 'properties[' + (box.dataset.prop || 'Treść') + ' (szt. ' + i + ')]';
      t.placeholder = i === 1 ? text.getAttribute('placeholder') || '' : 'Napis na sztuce nr ' + i;
      t.value = value || '';
      bindField(t);
      wrap.appendChild(label);
      wrap.appendChild(t);
      multiList.appendChild(wrap);
    }
    function syncMulti() {
      if (!multiWrap) return;
      var q = getQty();
      multiWrap.hidden = box.hidden || !info.text || q < 2;
      var keep = [];
      multiList.querySelectorAll('textarea').forEach(function (t) { keep.push(t.value); });
      if (multiActive() && info.text) {
        if (!keep.length && text.value.trim()) keep.push(text.value);
        multiList.innerHTML = '';
        for (var i = 1; i <= q; i++) addMultiItem(i, keep[i - 1]);
        text.hidden = true;
        text.disabled = true;
        count.hidden = true;
        multiHint.textContent = 'Wpisz osobny napis dla każdej z ' + q + ' sztuk – każdy trafi do zamówienia. Układ z edytora dotyczy wszystkich sztuk.';
        if (activeField === text || !multiList.contains(activeField)) activeField = multiList.querySelector('textarea');
      } else {
        if (keep.length && !text.value.trim()) text.value = keep[0];
        multiList.innerHTML = '';
        text.hidden = !info.text;
        text.disabled = box.hidden || !info.text;
        count.hidden = !info.text;
        activeField = text;
        multiHint.textContent = multiToggle && multiToggle.checked && q > MAX_MULTI
          ? 'Przy więcej niż ' + MAX_MULTI + ' sztukach dołącz listę napisów jako plik (Excel, Word) w polu poniżej albo wpisz je w uwagach do zamówienia.'
          : '';
      }
      updateCount();
      des && des.refresh();
    }
    if (multiToggle) multiToggle.addEventListener('change', syncMulti);
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { setTimeout(syncMulti, 0); });
      qtyInput.addEventListener('input', function () { setTimeout(syncMulti, 0); });
    }
    bindField(text);
    var submitBtn = form.querySelector('button[type="submit"]');
    var hadSecondary = !!(submitBtn && submitBtn.classList.contains('button--secondary'));
    function payButtons(show) {
      var any = false;
      form.querySelectorAll('.shopify-payment-button').forEach(function (el) { any = true; el.style.display = show ? '' : 'none'; });
      if (submitBtn && hadSecondary && any) {
        submitBtn.classList.toggle('button--secondary', show);
        submitBtn.classList.toggle('button--primary', !show);
      }
    }
    var textBlock = box.querySelectorAll('[data-ts-textblock]');
    function update() {
      info = map[idInput ? idInput.value : ''] || { on: false };
      var on = !!info.on;
      box.hidden = !on;
      textBlock.forEach(function (el) { el.hidden = !info.text; });
      text.disabled = !on || !info.text;
      file.disabled = !on;
      if (confirmBox) confirmBox.disabled = !on || !info.text;
      plate.innerHTML = on && box.dataset.kind === 'puchar' && info.tab ? plateInfo(info.plate) : '';
      payButtons(!on);
      if (!on) { box.classList.remove('is-invalid'); box.classList.remove('needs-confirm'); }
      syncMulti();
      if (des) des.setInfo(info, on && info.tab ? plateDims(info.plate) : null);
    }
    function updateCount() { count.textContent = text.value.length + ' / ' + text.maxLength; }
    text.addEventListener('input', updateCount);
    file.addEventListener('change', function () {
      var f = file.files && file.files[0];
      var tooBig = f && f.size > maxBytes;
      box.classList.toggle('is-invalid', !!tooBig);
      if (des) des.setFile(f && !tooBig ? f : null);
    });
    root.addEventListener('change', function (e) {
      if (e.target === text || e.target === file || box.contains(e.target)) return;
      setTimeout(update, 0);
    });
    var preparing = false;
    function prepare(e) {
      if (box.hidden) return;
      if (file.files && file.files[0] && file.files[0].size > maxBytes) {
        e.preventDefault();
        e.stopImmediatePropagation();
        box.classList.add('is-invalid');
        file.focus();
        return;
      }
      if (confirmBox && !confirmBox.disabled && !confirmBox.checked && hasAnyText()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        box.classList.add('needs-confirm');
        var label = confirmBox.closest('label');
        if (label && label.scrollIntoView) label.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { confirmBox.focus({ preventScroll: true }); }, 300);
        return;
      }
      if (preparing) return;
      preparing = true;
      if (des) des.attach();
      // puste pola nie trafiają do koszyka jako pusta właściwość
      var restore = [];
      var multi = multiActive();
      if (!text.disabled && (multi || !text.value.trim())) { text.disabled = true; restore.push([text, false]); }
      if (!file.disabled && (!file.files || !file.files.length)) { file.disabled = true; restore.push([file, false]); }
      multiList && multiList.querySelectorAll('textarea').forEach(function (t) {
        if (!t.value.trim()) { t.disabled = true; restore.push([t, false]); }
      });
      setTimeout(function () {
        preparing = false;
        restore.forEach(function (r) { r[0].disabled = r[1]; });
        if (des) des.release();
      }, 0);
    }
    if (submitBtn) submitBtn.addEventListener('click', prepare, true);
    form.addEventListener('submit', prepare, true);
    if (idInput) idInput.addEventListener('change', update);
    update();
    updateCount();
  }

  window.tsPersoBoot = function () { document.querySelectorAll('[data-ts-perso]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.tsPersoBoot);
  else window.tsPersoBoot();
})();
